// Les dates métier (YYYY-MM-DD) sont manipulées comme des chaînes : jamais de
// conversion en Date locale, pour éviter les décalages de fuseau.

export function todayIn(timezone) {
  try {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone || undefined,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date())
  } catch (e) {
    return new Date().toISOString().slice(0, 10)
  }
}

function utc(ymd) {
  const [y, m, d] = ymd.split('-').map(Number)
  return Date.UTC(y, m - 1, d)
}

export function addDays(ymd, days) {
  return new Date(utc(ymd) + days * 86400000).toISOString().slice(0, 10)
}

export function monthStart(ymd) {
  return `${ymd.slice(0, 7)}-01`
}

export function previousMonth(ymd) {
  const [y, m] = ymd.split('-').map(Number)
  const start = new Date(Date.UTC(y, m - 2, 1))
  const end = new Date(Date.UTC(y, m - 1, 0))
  return { from: start.toISOString().slice(0, 10), to: end.toISOString().slice(0, 10) }
}

/** Dernier jour du mois d'une date métier (AAAA-MM-JJ). */
export function monthEnd(ymd) {
  const [y, m] = ymd.split('-').map(Number)
  return new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10)
}

/** Mois courant (AAAA-MM) décalé de `months` mois — utilisé par les calendriers. */
export function addMonths(ymd, months) {
  const [y, m] = ymd.slice(0, 7).split('-').map(Number)
  return new Date(Date.UTC(y, m - 1 + Number(months), 1)).toISOString().slice(0, 7)
}

export function daysBetween(from, to) {
  return Math.round((utc(to) - utc(from)) / 86400000)
}

/** 20/09/2026 — à partir d'une date métier ou d'un horodatage ISO. */
export function formatDate(value) {
  if (!value) return '—'
  const [y, m, d] = String(value).slice(0, 10).split('-')
  return y && m && d ? `${d}/${m}/${y}` : String(value)
}

export function formatDateTime(value, timezone) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }
  try {
    return new Intl.DateTimeFormat('fr-FR', { ...options, timeZone: timezone || undefined }).format(date)
  } catch (e) {
    return new Intl.DateTimeFormat('fr-FR', options).format(date)
  }
}

export function formatLongDate(ymd) {
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(new Date(utc(ymd)))
}

/** Libellé court d'une période de tendance (jour, semaine ou mois). */
export function formatPeriodLabel(period, groupBy) {
  if (!period) return ''
  if (groupBy === 'month') {
    const [y, m] = period.slice(0, 7).split('-')
    return `${m}/${y}`
  }
  const [, m, d] = period.slice(0, 10).split('-')
  return groupBy === 'week' ? `Sem. ${d}/${m}` : `${d}/${m}`
}

/** Valeur d'un <input type="datetime-local"> → ISO 8601 (UTC). */
export function localInputToIso(value) {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d.toISOString()
}
